import { getAccessToken } from "../auth/tokenStorage";

type StreamOptions = {
  bufferService?: string;
  signal?: AbortSignal;
};

/**
 * Request the assistant response stream for a given user message.
 * Returns the ReadableStream reader so callers can iterate over SSE chunks.
 */
export async function streamAssistantMessage(
  userMessageId: string,
  { bufferService, signal }: StreamOptions = {}
): Promise<ReadableStreamDefaultReader<Uint8Array>> {
  const params = new URLSearchParams();
  if (bufferService) {
    params.set("buffer_service", bufferService);
  }

  const query = params.toString();
  const url = `${window.appConfig.apiUrl}/chat/stream/${userMessageId}${
    query ? `?${query}` : ""
  }`;

  const token = getAccessToken();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "text/event-stream",
      "Cache-Control": "no-cache",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to stream assistant message: ${response.statusText}`
    );
  }

  const body = response.body;
  if (!body) {
    throw new Error("Stream response does not contain a body");
  }

  return body.getReader();
}
